// PRODUCTION — admin flow editor
import React from 'react'
import tw, { css } from 'twin.macro'

const pulse = css`
  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
  }
  animation: pulse 1.5s ease-in-out infinite;
`

const SkeletonBlock = ({
  height = 20,
  width = '100%',
  rounded = 6,
}: {
  height?: number
  width?: string | number
  rounded?: number
}) => <div css={[tw`bg-shades-100`, pulse]} style={{ height, width, borderRadius: rounded }} />

export const FlowEditorSkeleton = () => (
  <div css={tw`max-w-5xl mx-auto px-6 py-8 flex flex-col gap-6`}>
    {/* Header skeleton */}
    <div css={tw`flex items-center gap-3`}>
      <SkeletonBlock height={32} width={360} rounded={8} />
      <div css={tw`flex-1`} />
      <SkeletonBlock height={36} width={120} rounded={8} />
    </div>

    {/* Two-column layout skeleton */}
    <div css={tw`flex gap-4 items-start`}>
      {/* Left: Step list */}
      <div
        css={tw`w-[332px] flex-shrink-0 border border-shades-200 rounded-xl overflow-hidden border-solid`}
      >
        {/* List header */}
        <div
          css={tw`flex items-center justify-between p-4 border-0 border-b border-solid border-shades-100`}
        >
          <SkeletonBlock height={20} width={60} />
          <SkeletonBlock height={28} width={80} rounded={7} />
        </div>
        {/* Step rows */}
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            css={tw`flex items-center gap-3 px-4 py-3 border-b border-shades-100 border-solid`}
          >
            <SkeletonBlock height={22} width={22} rounded={11} />
            <SkeletonBlock height={16} width={`${60 + Math.random() * 40}%`} />
          </div>
        ))}
      </div>

      {/* Right: Config panel */}
      <div css={tw`flex-1 border border-shades-200 rounded-xl overflow-hidden border-solid`}>
        {/* Panel header */}
        <div css={tw`flex items-center gap-3 p-4 border-b border-shades-100 border-solid`}>
          <SkeletonBlock height={24} width={100} rounded={6} />
          <SkeletonBlock height={20} width={140} />
          <div css={tw`flex-1`} />
          <SkeletonBlock height={30} width={100} rounded={8} />
        </div>
        {/* Config rows */}
        <div css={tw`flex flex-col`}>
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              css={tw`flex items-center gap-4 px-5 py-4 border-b border-shades-100 border-solid`}
            >
              <SkeletonBlock height={16} width={140} />
              <SkeletonBlock height={38} width="100%" rounded={8} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
)
